<template>
  <modal
    name="logo-improvement-request-success-modal"
    :adaptive="true"
    :click-to-close="true"
    class="logo-improvement-request-success-modal"
    height="auto"
  >
    <cv-icon-button
      class="logo-improvement-request-success-modal--close-button"
      :label="'close'"
      tip-position="right"
      tip-alignment="start"
      kind="ghost"
      @click="$emit('action:cancel')"
    >
      <template #icon>
        <close-20 />
      </template>
    </cv-icon-button>
    <div class="logo-improvement-request-success-modal mt-20 mb-20">
      <label class="logo-improvement-request-success-modal__header">
        {{
          $t(
            'wizard-v2.small-details.improvement-modal.successfully-requested-logo-improvements'
          )
        }}
      </label>
      <div class="logo-improvement-request-success-modal__content">
        <p class="mt-20">
          {{
            $t('wizard-v2.small-details.improvement-modal.process-description')
          }}
        </p>
        <p class="mt-20 bold">
          <b>{{ $t('wizard-v2.small-details.improvement-modal.options') }}</b>
        </p>
        <ol>
          <li class="mt-10">
            {{ $t('wizard-v2.small-details.improvement-modal.option-1') }}
          </li>
          <li class="mt-10">
            {{ $t('wizard-v2.small-details.improvement-modal.option-2') }}
          </li>
        </ol>
        <p class="mt-20">
          {{ $t('wizard-v2.small-details.improvement-modal.end-message') }}
        </p>
      </div>
    </div>
    <cv-row>
      <cv-column :sm="16" :md="16" :lg="16" :xlg="16" :max="16"
        ><div class="cv-grid-story__preview-col">
          <cv-button-set>
            <cv-button
              id="small-details-check-replace-logo"
              kind="primary"
              @click="$emit('action:cancel')"
              >{{ $t('dialog.actions.continue') }}</cv-button
            >
          </cv-button-set>
        </div></cv-column
      ></cv-row
    >
  </modal>
</template>

<script>
import {
  CvRow,
  CvColumn,
  CvButton,
  CvButtonSet,
  CvIconButton,
} from '@carbon/vue';
import Close20 from '@carbon/icons-vue/es/close/20';

export default {
  components: {
    CvButton,
    CvRow,
    CvColumn,
    CvButtonSet,
    CvIconButton,
    Close20,
  },
};
</script>

<style lang="scss">
.logo-improvement-request-success-modal {
  font-size: 16px;
  padding: 10px;

  &__header {
    font-size: 20px;
  }

  &__content {
    font-size: 16px !important;
    ol {
      list-style-type: decimal;
      margin-left: 25px;
    }

    p {
      font-size: 16px !important;
    }
  }
}

.logo-improvement-request-success-modal .bx--btn {
  height: 48px;
  max-width: 50% !important;
  font-size: 14px !important;
}

.logo-improvement-request-success-modal .bold {
  font-weight: bold;
}

.logo-improvement-request-success-modal .cv-button-set {
  justify-content: end;
}

.logo-improvement-request-success-modal--close-button {
  position: absolute !important;
  right: 0 !important;
}
</style>
